import { Component, ViewContainerRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { GalleryService } from '../../../services';
import { GalleryListModel } from '../../../models/gallery';
import { AppUtils } from '../../../helpers';

import { GallerySearchResultComponent } from '../search-result/gallery.search.result.component';

@Component({
    selector: 'user-gallery',
    templateUrl: './user.gallery.component.html'
})

export class UserGalleryComponent implements OnInit {
    @BlockUI('conatiner-add-gallery') blockUIAddGallery: NgBlockUI;
    @BlockUI('conatiner-gallery-list') blockUIGalleryList: NgBlockUI;

    @ViewChild(GallerySearchResultComponent) gallerySearchResult: GallerySearchResultComponent;

    constructor(private vcr: ViewContainerRef,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private galleryService: GalleryService,
        private appUtils: AppUtils) {
        this.toastr.setRootViewContainerRef(this.vcr);
    }

    private modalReference: any;

    model: any = {
        name: null
    };

    filterKey: string;

    galleries: Array<GalleryListModel> = new Array<GalleryListModel>();
    filteredGalleris: Array<GalleryListModel> = new Array<GalleryListModel>();

    selectedGallery: GalleryListModel = new GalleryListModel();

    ngOnInit() {
        this.loadGalleries();
    }

    open(content: any) {
        this.modalReference = this.modalService.open(content);
    }

    close() {
        this.modalReference.close();
    }

    create() {
        this.blockUIAddGallery.start();
        this.galleryService.create(this.model).subscribe(
            (data: any) => {
                this.blockUIAddGallery.stop();
                this.toastr.success('Gallery has been created successfully.');
                this.model = {
                    name: null
                };
                this.close();
                this.loadGalleries();
            },
            error => {
                this.blockUIAddGallery.stop();
                this.appUtils.ProcessErrorResponse(this.toastr, error);
            });
    }

    loadGalleries() {
        this.blockUIGalleryList.start();
        this.galleryService.getGalleries().subscribe(
            (data: any) => {
                this.blockUIGalleryList.stop();
                Object.assign(this.galleries, data);

                if (this.galleries.length !== 0) {
                    this.galleries.map((item) => {
                        item.createdOn = this.appUtils.getFormattedDate(item.createdOn, null);
                    });
                }

                Object.assign(this.filteredGalleris, this.galleries);

                this.loadDefaultDesigns();

            }, error => {
                this.blockUIGalleryList.stop();
                this.appUtils.ProcessErrorResponse(this.toastr, error);
            });
    }

    deleteGallery(gallery: GalleryListModel) {
        if (!confirm('Are you sure you want to delete selected gallery?')) {
            return;
        }
        this.blockUIGalleryList.start();
        this.galleryService.deleteGallery(gallery.id)
            .subscribe(
                (data: any) => {
                    this.blockUIGalleryList.stop();
                    this.toastr.success('Gallery has been deleted successfully');
                    const deletedItemIndex = this.galleries.indexOf(gallery);
                    this.galleries.splice(deletedItemIndex, 1);
                    setTimeout(() => {
                        this.filterGalleries();
                    }, 100);
                }, error => {
                    this.blockUIGalleryList.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    filterGalleries() {
        this.filteredGalleris = this.galleries.filter(item => !this.filterKey
            || item.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) !== -1);
    }

    loadDesigns(gallery: GalleryListModel) {
        this.selectedGallery = gallery;
        this.gallerySearchResult.loadDesigns(this.selectedGallery);
    }

    loadDefaultDesigns() {
        if (this.filteredGalleris.length === 0) {
            return;
        }
        const defaultGallery = this.filteredGalleris[0];
        this.loadDesigns(defaultGallery);
    }
}



// WEBPACK FOOTER //
// ./src/components/gallery/user-gallery/user.gallery.component.ts